/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as R from 'ramda';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { withBorder } from '../../reactutils/withBorder';
import { withNavLocation } from '../../reactutils/withNavLocation';
import { FuntipTitle } from '../../reactutils/withTitle';
import { Ranking } from '../../services/betting';
import { LoadingIndicatorSpinner2 } from '../common/LoadingIndicatorSpinner2';
import { usePathSegment } from '../SysAdminApp/CacheStatisticsComponent';
import { getRankingApi2 } from '../System/systemConfig';
import { TournamentSelectionComponent } from '../TournamentSelectionComponent';
import { TournamentRoundSelectionComponent2 } from '../TournamentSelectionComponent/TournamentRoundSelectionComponent';
import { rankingLoadWithoutProps } from './actions';
import { GroupRanking } from './components/GroupRanking';

export const RankingComponentWithoutRound: React.FC<{}> = () => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(rankingLoadWithoutProps());
    }, [dispatch]);
    return null;
};

const RankingComponent: React.FC<{}> = () => {
    const CACHE_NAME = 'rankingCache';

    const [trId] = usePathSegment(3);

    const { data, isLoading, isSuccess } = useQuery({
        queryKey: [CACHE_NAME, trId],
        queryFn: () => getRankingApi2().getRanking({ trId: Number(trId) }),
    });

    function groupRankings(groupRanking: Ranking) {
        return <GroupRanking key={groupRanking.tournamentGroupId} ranking={groupRanking} isLoading={isLoading} />;
    }

    return (
        <>
            <FuntipTitle
                title="Tabellen"
                subTitle=""
                leftComponent={
                    <TournamentSelectionComponent onTournamentChange={(tId: string) => rankingLoadWithoutProps()} />
                }
                rightComponent={
                    <TournamentRoundSelectionComponent2
                        trId={trId}
                        pathByTournamentRound={rankingPath}
                        type="ranking"
                    />
                }
            />
            <LoadingIndicatorSpinner2 isLoading={isLoading}>
                {isSuccess && data.map((r) => groupRankings(r))}
            </LoadingIndicatorSpinner2>
        </>
    );
};

export const rankingPath = (trId: string) => `/b/ranking/${trId}`;

export const RankingScreen = R.compose(withBorder(), withNavLocation('ranking'))(RankingComponent);
